export default {"src":"/_next/static/media/VendorIcon.0065e9bc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};